<div class="d-flex align-items-center justify-content-between p-2">
    <div class="ship_scan_search d-flex align-items-center">
        <span class="ship_scan_search_icon">
            <i class="fal fa-search"></i>
        </span>
        <input type="text" placeholder="Search or scan"  max="50" (keyup)="onKeyup($event)" class="ship_scan_search_input">
    </div>
    <div class="d-flex justify-content-end">
        <div class="column_action" matTooltip="Scan" (click)="setScanner();isScanning=!isScanning">
            <app-button [buttonSize]="'action'" [buttonColor]="isScanning ? 'success' : 'primary'"
                [buttonStyle]="'primary'">
                <i class="fal fa-scanner" [ngClass]="{ 'scan': isScanning }"></i>
            </app-button>
        </div>
        <div class="header-button d-flex align-items-center">
            <span class="header-button_name qtyscanLabel">Qty per scan</span>
            <input type="number" [(ngModel)]="scanedQty" class="qtyscanInp">
        </div>
    </div>
</div>
<div class="ship_scan_dimension">
    <form [formGroup]="form" >
        <div class="box">
          <div class="box_header">
            <div class="box_dimensions">     
              <div class="input-container">
                <label class="input-container_label mb-0">Weight:</label>
                <input
                      type="number"
                      class="input-container_input input-container_input--small"
                      placeholder="lb"
                      formControlName="weight"
                      min="0"
                      (change)="onChange($event,'weight')"
                    />
                    </div>
                  
                  <div class="input-container">
                    <label class="input-container_label mb-0">Dimension:</label>
                    <input
                    type="number"
                    class="input-container_input input-container_input--small"   
                    placeholder="in"
                    formControlName="length"
                    min="0"
                    (change)="onChange($event,'length')"
                    />
                    <span class="input-container_times">x</span>
                    <input
                    type="number"
                    class="input-container_input input-container_input--small"
                    placeholder="in"
                    formControlName="width"
                    min="0"
                    (change)="onChange($event,'width')"
                    />
                    <span class="input-container_times">x</span>
                    <input
                      type="number"
                      class="input-container_input input-container_input--small"
                      placeholder="in"
                      formControlName="height"
                      min="0"
                      (change)="onChange($event,'height')"
                    />
              </div>
            </div>
          </div>
        </div>
        </form>
    </div>
<app-fbm-productdetails #fbmProductdetailsComponent [productList]="searchproductList"></app-fbm-productdetails>